<div class="form-group container" id="training-detail-detail-component" *ngIf="training">
        <form (submit)="save()">
            <div class="row" style="margin-bottom: 50px;">
                <div>
                    <h3>{{ 'training-detail.training.details.base' | translate}}</h3>
                    <div style="margin-top:30px;">
                        <div>
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <div class="col-md-12">
                                    <input type="checkbox" id="active"
                                           [(ngModel)]="training.active" name="active"
                                           #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                    <label for="active">{{ 'training-detail.training.details.active' | translate}}</label>
                                    <label *jhiHasAnyAuthority="'!ROLE_ADMIN'"> : {{getBoolTranslateKey(training.active) |
                                        translate}}</label>
                                </div>
                            </div>
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <div class="col-md-12">
                                    <div class="col-md-3 training-title-admin" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <label for="reference" class="required">{{ 'training-detail.training.details.reference' |
                                            translate}}</label>
                                    </div>
                                    <div class="col-md-3" *jhiHasAnyAuthority="'!ROLE_ADMIN'">
                                        <label for="reference" class="required">{{ 'training-detail.training.details.reference' |
                                            translate}}</label>
                                    </div>
                                    <div class="col-md-9">
                                        <input type="text" class="form-control" id="reference"
                                               required
                                               [(ngModel)]="training.reference" name="reference"
                                               #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{training.reference}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <div class="col-md-12">
                                    <div class="col-md-3 training-title-admin" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <label for="outline" class="required">{{ 'training-detail.training.details.catalogUrl' | translate}}:</label>
                                    </div>
                                    <div class="col-md-3" *jhiHasAnyAuthority="'!ROLE_ADMIN'">
                                        <label for="outline" class="required">{{ 'training-detail.training.details.catalogUrl' | translate}}</label>
                                    </div>
                                    <div class="col-md-9">
                                        <input type="text" class="form-control" id="outline"
                                               required
                                               [(ngModel)]="training.outline" name="outline"
                                               #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{training.outline}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <div class="col-md-12">
                                    <div class="col-md-3 training-title-admin" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <label for="theoryRatio">{{ 'training-detail.training.details.theoryRatio' | translate}}</label>
                                    </div>
                                    <div class="col-md-3" *jhiHasAnyAuthority="'!ROLE_ADMIN'">
                                        <label for="theoryRatio">{{ 'training-detail.training.details.theoryRatio' | translate}}</label>
                                    </div>
                                    <div class="col-md-9">
                                        <input type="text" class="form-control" id="theoryRatio"
                                               [(ngModel)]="training.theory_ratio" name="theoryRatio"
                                               #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{training.theory_ratio}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <div class="col-md-12">
                                    <div class="col-md-3 training-title-admin" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <label for="days" class="required">{{ 'training-detail.training.details.days' | translate}}:</label>
                                    </div>
                                    <div class="col-md-3" *jhiHasAnyAuthority="'!ROLE_ADMIN'">
                                        <label for="days" class="required">{{ 'training-detail.training.details.days' | translate}}</label>
                                    </div>
                                    <div class="col-md-9">
                                        <input type="text" class="form-control" id="days"
                                               required
                                               [ngModel]="training.days | commaDot"
                                               (ngModelChange)="training.days=$event"
                                               name="days"
                                               #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{training.days}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-bottom: 50px;">
                <div>
                    <h3>{{ 'training-detail.training.details.partner' | translate}}</h3>
                    <div style="margin-top:30px;">
                        <div>
                            <div class="col-md-12 plt-b-spaced">
                                <div class="col-md-12">
                                    <div class="col-md-3 training-title-admin" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <label for="partner">{{ 'training-detail.training.details.partner' | translate}}</label>
                                    </div>
                                    <div class="col-md-3" *jhiHasAnyAuthority="'!ROLE_ADMIN'">
                                        <label for="partner">{{ 'training-detail.training.details.partner' | translate}}</label>
                                    </div>
                                    <div class="col-md-9">
                                        <select class="form-control" id="partner" [(ngModel)]="training.partnerId"
                                                name="partner" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                            <option value="">{{ 'training-detail.training.details.none' | translate}}</option>
                                            <option *ngFor="let partner of partners" [ngValue]="partner.id">
                                                {{partner.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <div class="col-md-12" *ngIf="training.partnerId">
                                    <div class="col-md-3 training-title-admin">
                                        <label for="partnerFees">{{ 'training-detail.training.details.partnerFees' | translate}}</label>
                                    </div>
                                    <div class="col-md-6">
                                       <input
                                           type="number"
                                           id="partnerFees"
                                           class="form-control"
                                           name="fees"
                                           [(ngModel)]="training.partnerFees"
                                       >
                                    </div>
                                    <div class="col-md-3">
                                        <select
                                            class="form-control"
                                            name="partnerFeesCurrencyCode"
                                            [(ngModel)]="training.partnerFeesCurrencyCode"
                                            *jhiHasAnyAuthority="'ROLE_ADMIN'"
                                        >
                                            <option
                                                *ngFor="let x of 'training-detail.training.details.countries' | translate | removeDuplicate"
                                                [ngValue]="x.currencyCode"
                                            >
                                                {{x.currencyCode}}
                                            </option>
                                        </select>
                                        <span class="prices-info" *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{training.partnerFeesCurrencyCode}}</span>
                                    </div>
                                </div>
                                <div class="col-md-7" *ngIf="!training.partnerId"></div>
                            </div>
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <div class="col-md-12" *ngIf="training.partnerId">
                                    <div class="col-md-3">
                                        <label>{{"training-detail.training.details.partnerFeesMode.label" | translate}}</label>
                                    </div>
                                    <div class="col-md-3">
                                        <label>
                                            <input
                                                type="radio"
                                                name="partnerFeesMode"
                                                value="PER_PARTICIPANT"
                                                [(ngModel)]="training.partnerFeesMode"
                                            >
                                            {{"training-detail.training.details.partnerFeesMode.perParticipant" | translate}}
                                        </label>
                                    </div>
                                    <div class="col-md-6">
                                        <label>
                                            <input
                                                type="radio"
                                                name="partnerFeesMode"
                                                value="PER_DAY"
                                                [(ngModel)]="training.partnerFeesMode"
                                            >
                                            {{"training-detail.training.details.partnerFeesMode.perDay" | translate}}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-7" *ngIf="!training.partnerId"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-bottom: 50px;">
                <div>
                    <h3>{{ 'training-detail.training.details.training-type' | translate}}</h3>
                    <div style="margin-top:30px;">
                        <div>
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <div class="col-md-3">
                                    <input type="checkbox" id="official"
                                           [(ngModel)]="training.official" name="official"
                                           #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                    <label for="official">{{ 'training-detail.training.details.official' | translate}}</label>
                                    <label *jhiHasAnyAuthority="'!ROLE_ADMIN'"> : {{getBoolTranslateKey(training.official) |
                                        translate}}</label>
                                </div>
                                <div class="col-md-3">
                                    <input type="checkbox" id="certifying"
                                           [(ngModel)]="training.certifying" name="certifying"
                                           #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                    <label for="certifying">{{ 'training-detail.training.details.certifying' | translate}}</label>
                                    <label *jhiHasAnyAuthority="'!ROLE_ADMIN'"> : {{getBoolTranslateKey(training.certifying) |
                                        translate}}</label>
                                </div>
                                <div class="col-md-3">
                                    <input type="checkbox" id="exclusive"
                                           [(ngModel)]="training.exclusive" name="exclusive"
                                           #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                    <label for="exclusive">{{ 'training-detail.training.details.exclusive' | translate}}</label>
                                    <label *jhiHasAnyAuthority="'!ROLE_ADMIN'"> : {{getBoolTranslateKey(training.exclusive) |
                                        translate}}</label>
                                </div>
                            </div>
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <div class="col-md-3">
                                    <input
                                        type="checkbox"
                                        id="isZenboxWorkshop"
                                        [(ngModel)]="training.isZenboxWorkshop"
                                        name="isZenboxWorkshop"
                                        *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                    <label for="isZenboxWorkshop">
                                        {{ 'training-detail.training.details.isZenboxWorkshop' | translate}}
                                    </label>
                                    <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">
                                        : {{getBoolTranslateKey(training.isZenboxWorkshop) | translate}}
                                    </label>
                                </div>
                                <div class="col-md-3">
                                    <input
                                        type="checkbox"
                                        id="isZenboxTalk"
                                        [(ngModel)]="training.isZenboxTalk"
                                        name="isZenboxTalk"
                                        *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                    <label for="isZenboxTalk">
                                        {{ 'training-detail.training.details.isZenboxTalk' | translate}}
                                    </label>
                                    <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">
                                        : {{getBoolTranslateKey(training.isZenboxTalk) | translate}}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-bottom: 50px;">
                <div>
                    <h3>{{ 'training-detail.training.details.publication' | translate}}</h3>
                    <div style="margin-top:30px;">
                        <div>
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <div class="col-md-12">
                                    <input
                                        type="checkbox"
                                        id="published"
                                        [(ngModel)]="training.published"
                                        name="published"
                                        #name="ngModel"
                                        *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                    <label for="published">
                                        {{ 'training-detail.training.details.published' | translate}}
                                    </label>
                                    <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">
                                        : {{getBoolTranslateKey(training.published) | translate}}
                                    </label>
                                </div>
                            </div>
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <div class="col-md-12">
                                    <input
                                        type="checkbox"
                                        id="publishedUnlisted"
                                        [(ngModel)]="training.publishedUnlisted"
                                        name="publishedUnlisted"
                                        #name="ngModel"
                                        *jhiHasAnyAuthority="'ROLE_ADMIN'"
                                        [disabled]="!training.published">
                                    <label for="publishedUnlisted">
                                        {{ 'training-detail.training.details.publishedUnlisted' | translate}}
                                    </label>
                                    <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">
                                        : {{getBoolTranslateKey(training.publishedUnlisted) | translate}}
                                    </label>
                                </div>
                            </div>
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <div class="col-md-12">
                                    <input
                                        type="checkbox"
                                        id="remoteReady"
                                        [(ngModel)]="training.remoteReady"
                                        name="remoteReady"
                                        *jhiHasAnyAuthority="'ROLE_ADMIN'"
                                        [disabled]="!training.published">
                                    <label for="remoteReady">
                                        {{ 'training-detail.training.details.remoteReady' | translate}}
                                    </label>
                                    <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">
                                        : {{getBoolTranslateKey(training.remoteReady) | translate}}
                                    </label>
                                </div>
                            </div>
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <div class="col-md-12">
                                    <input
                                        type="checkbox"
                                        id="onDemand"
                                        [(ngModel)]="training.onDemand"
                                        name="onDemand"
                                        *jhiHasAnyAuthority="'ROLE_ADMIN'"
                                        [disabled]="!training.published">
                                    <label for="onDemand">
                                        {{ 'training-detail.training.details.onDemand' | translate}}
                                    </label>
                                    <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">
                                        : {{getBoolTranslateKey(training.onDemand) | translate}}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-bottom: 50px;">
                <div>
                    <h3>{{ 'training-detail.training.details.universes' | translate}}</h3>
                    <div class="catalog">
                        <div class="row">
                            <div class="plt-display-row col-md-12 plt-b-spaced"
                                 *ngFor="let trainingUniverse of training.trainingUniverses; let i=index; trackBy: trackByFn">
                                <div class="col-md-12">
                                    <div class="col-md-6">
                                        {{ 'training-detail.training.details.universe.name' | translate }}
                                        <select class="form-control" name="universe-{{i}}" [(ngModel)]="trainingUniverse.universeId" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                            <option *ngFor="let universe of universes" [ngValue]="universe.id">
                                                {{universe.name}}
                                            </option>
                                        </select>
                                        <input style="display:none;" class="form-control" name="universe-{{i}}"
                                               [(ngModel)]="trainingUniverse.universeId">
                                        <span class="universe-info"
                                              *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{ getUniverseName(trainingUniverse.universeId) }}</span>
                                    </div>

                                    <div class="col-md-5">
                                        {{ 'training-detail.training.details.universe.order' | translate }}
                                        <input class="form-control" name="order-{{i}}" type="number" min="0" [(ngModel)]="trainingUniverse.order" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <span class="universes-info"
                                              *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{trainingUniverse.order}}</span>
                                    </div>

                                    <div class="icon-remove col-md-1" (click)="removeUniverse(i)" style="margin-top: 20px">
                                        <i class="fa fa-trash-o fa-2x" aria-hidden="true" *jhiHasAnyAuthority="'ROLE_ADMIN'"></i>
                                    </div>

                                </div>
                            </div>
                            <button class="btn btn-default" type="button" (click)="addNewUniverse()" *jhiHasAnyAuthority="'ROLE_ADMIN'">{{ 'training-detail.training.details.new' | translate }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" style="margin-bottom: 50px;">
                <div>
                    <h3>{{ 'training-detail.training.details.prices' | translate}}</h3>
                    <div class="catalog">
                        <div class="row">
                            <div class="plt-display-row col-md-12 plt-b-spaced" *ngFor="let item of training.trainingPrices; let i=index; trackBy: trackByFn">
                                <div class="col-md-12">
                                    <div class="col-md-3">
                                        {{ 'training-detail.training.details.priceCountry' | translate }}
                                        <select class="form-control" name="countryCode-{{i}}" (change)="change($event.target.options[$event.target['selectedIndex']].text, item);" [(ngModel)]="item.countryCode" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                            <option *ngFor="let x of 'training-detail.training.details.countries' | translate | removeDuplicate "
                                            [ngValue]="x.countryCode">
                                                {{x.country}}
                                            </option>
                                        </select>
                                        <input style="display:none;" class="form-control" name="country-{{i}}" [(ngModel)]="item.country">
                                        <span class="prices-info" *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{item.country}}</span>
                                    </div>

                                    <div class="col-md-3">
                                        {{ 'training-detail.training.details.priceCity' | translate }}
                                        <select class="form-control" name="city-{{i}}" [(ngModel)]="item.city" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                            <option *ngFor="let x of 'training-detail.training.details.countries' | translate | filter : item.countryCode"
                                            [ngValue]="x.city">
                                                {{x.city}}
                                            </option>
                                        </select>
                                        <span class="prices-info" *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{item.city}}</span>
                                    </div>

                                    <div class="col-md-3">
                                        {{ 'training-detail.training.details.priceTraining' | translate }}
                                        <input class="form-control" name="price-{{i}}" type="number" min="0" [(ngModel)]="item.price" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <span class="prices-info" *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{item.price}}</span>
                                    </div>

                                    <div class="col-md-2">
                                        {{ 'training-detail.training.details.priceCurrencyCode' | translate }}
                                        <select class="form-control" name="currencyCode-{{i}}" [(ngModel)]="item.currencyCode" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                            <option *ngFor="let x of 'training-detail.training.details.countries' | translate | filter : item.countryCode | removeDuplicate"
                                            [ngValue]="x.currencyCode">
                                                {{x.currencyCode}}
                                            </option>
                                        </select>
                                        <span class="prices-info" *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{item.currencyCode}}</span>
                                    </div>
                                    <div class="icon-remove col-md-1" (click)="removeCity(i)" style="margin-top: 20px"><i class="fa fa-trash-o fa-2x" aria-hidden="true" *jhiHasAnyAuthority="'ROLE_ADMIN'"></i></div>
                                </div>
                            </div>
                            <button class="btn btn-default" type="button" (click)="addNewCity()" *jhiHasAnyAuthority="'ROLE_ADMIN'">{{ 'training-detail.training.details.new' | translate }}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-bottom: 50px;">
                <div>
                    <h3>{{ 'training-detail.training.details.studentQuotes.title' | translate}}</h3>
                    <div class="catalog">
                        <div class="row">
                            <div class="plt-display-row col-md-12 plt-b-spaced" *ngFor="let item of training.studentQuotes; let i=index; trackBy: trackByFn">
                                <div class="col-md-12">

                                    <div class="col-md-2">
                                        {{ 'training-detail.training.details.studentQuotes.author' | translate }}
                                        <input class="form-control" name="student-quote-author-{{i}}" [(ngModel)]="item.author" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <span class="quote-info" *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{item.author}}</span>
                                    </div>

                                    <div class="col-md-2">
                                        {{ 'training-detail.training.details.studentQuotes.date' | translate }}
                                        <input class="form-control" name="student-quote-date-{{i}}" type="date" [(ngModel)]="item.date" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <span class="quote-info" *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{item.date}}</span>
                                    </div>

                                    <div class="col-md-7">
                                        {{ 'training-detail.training.details.studentQuotes.quote' | translate }}
                                        <input class="form-control" name="student-quote-quote-{{i}}" [(ngModel)]="item.quote" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <span class="quote-info" *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{item.quote}}</span>
                                    </div>

                                    <div class="icon-remove col-md-1" (click)="removeStudentQuote(i)" style="margin-top: 20px"><i class="fa fa-trash-o fa-2x" aria-hidden="true" *jhiHasAnyAuthority="'ROLE_ADMIN'"></i></div>
                                </div>
                            </div>
                            <button class="btn btn-default" type="button" (click)="addNewStudentQuote()" *jhiHasAnyAuthority="'ROLE_ADMIN'">{{ 'training-detail.training.details.new' | translate }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div>
                    <h3 class="catalog-title">{{ 'training-detail.training.details.catalog' | translate}}</h3>
                    <div class="language-selector" *ngIf="!creationMode">
                        <span [ngClass]="{'selected': language === 'fr'}" (click)="switchLanguage('fr')">Français</span>
                        -
                        <span [ngClass]="{'selected': language === 'en'}" (click)="switchLanguage('en')">Anglais</span>
                    </div>
                    <div class="language-selector" *ngIf="creationMode">
                        <span class="selected">Français</span>
                        -
                        <span><del>Anglais</del></span>
                    </div>

                    <div class="catalog">
                        <div class="row">
                            <div class="col-md-12 plt-b-spaced">
                                <div class="col-md-6">
                                    <div class="col-md-3 training-title-admin" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <label for="title" class="required">{{ 'training-detail.training.details.title' |
                                            translate}}</label>
                                    </div>
                                    <div class="col-md-3" *jhiHasAnyAuthority="'!ROLE_ADMIN'">
                                        <label for="title" class="required">{{ 'training-detail.training.details.title' |
                                            translate}}</label>
                                    </div>
                                    <div class="col-md-9">
                                        <input type="text" class="form-control" id="title"
                                               required
                                               [(ngModel)]="training.title" name="title"
                                               #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{training.title}}</label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div>
                                        <input
                                            type="checkbox"
                                            [(ngModel)]="training.publishAsNew"
                                            name="publishAsNew"
                                            #name="ngModel"
                                            *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <label>
                                            {{ 'training-detail.training.details.publishAsNew' | translate}}
                                        </label>
                                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">
                                            : {{getBoolTranslateKey(training.publishAsNew) | translate}}
                                        </label>
                                    </div>
                                    <div>
                                        <input
                                            type="checkbox"
                                            [(ngModel)]="training.materialReady"
                                            name="materialReady"
                                            #name="ngModel"
                                            *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <label>
                                            {{ 'training-detail.training.details.materialReady' | translate}}
                                        </label>
                                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">
                                            : {{getBoolTranslateKey(training.materialReady) | translate}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 plt-b-spaced">
                                <div class="col-md-6">
                                    <div class="col-md-3 training-title-admin" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <label for="subTitle" class="required">{{ 'training-detail.training.details.subtitle' |
                                            translate}}</label>
                                    </div>
                                    <div class="col-md-3" *jhiHasAnyAuthority="'!ROLE_ADMIN'">
                                        <label for="subtitle" class="required">{{ 'training-detail.training.details.subtitle' |
                                            translate}}</label>
                                    </div>
                                    <div class="col-md-9">
                                        <input type="text" class="form-control" id="subTitle"
                                               required
                                               [(ngModel)]="training.subTitle" name="subTitle"
                                               #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{training.subTitle}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 plt-b-spaced">
                                <div class="picture-actions col-md-6">
                                    <div class="col-md-3">
                                        <label>Logo</label>
                                    </div>

                                    <div *ngIf="trainingPicturePath" class="col-md-5">
                                        <img class="catalog-logo"
                                             src="{{trainingPicturePath+'?timeupdate='+time}}"/>
                                    </div>

                                    <div *ngIf="trainingPicturePath" class="col-md-4">
                                        <label class="btn btn-default" style="margin-bottom: 4px; margin-right: 10px">
                                            {{ 'training-detail.picture.change-default' | translate}}
                                            <input (change)="trainingPictureFileChange($event)"
                                                   type="file" style="display: none;" accept="image/*">
                                        </label>

                                        <br/>
                                        <button class="btn btn-default" (click)="resetPicture($event)">
                                            {{ 'training-detail.picture.reset-default' | translate}}
                                        </button>
                                    </div>

                                    <div *ngIf="!trainingPicturePath" class="col-md-9">
                                        <label class="btn btn-default" style="margin-bottom: 4px; margin-right: 10px">
                                            {{ 'training-detail.picture.set-default' | translate}}
                                            <input (change)="trainingPictureFileChange($event)"
                                                   type="file" style="display: none;" accept="image/*">
                                        </label>
                                    </div>

                                    {{pictureFileError}}
                                </div>
                            </div>
                        </div>
                        <div class="metadata">
                            <div class="row">
                                <div class="col-md-12">
                                    <label for="presentation">{{ 'training-detail.training.details.presentation' | translate}}</label>
                                </div>

                                <div class="col-md-12">
                                    <textarea class="form-control" id="presentation"
                                              [(ngModel)]="training.description" name="presentation"
                                              #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'"></textarea>
                                    <span *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{training.description}}</span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <label for="resources">{{ 'training-detail.training.details.resources' | translate}}</label>
                                </div>

                                <div class="col-md-12">
                                    <textarea class="form-control" id="resources"
                                              [(ngModel)]="training.resources" name="resources"
                                              #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'"></textarea>
                                    <span *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{training.resources}}</span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <label for="objectives">{{ 'training-detail.training.details.objectives' |
                                                translate}}</label>
                                        </div>
                                        <div class="col-md-12">
                                                <textarea class="form-control" id="objectives"
                                                          [(ngModel)]="training.objectives" name="objectives"
                                                          #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'"></textarea>
                                            <span *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{training.objectives}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <label for="prerequisites">{{ 'training-detail.training.details.prerequisites' |
                                                translate}}</label>
                                        </div>
                                        <div class="col-md-12">
                                                <textarea class="form-control" id="prerequisites"
                                                          [(ngModel)]="training.prerequisites" name="prerequisites"
                                                          #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'"></textarea>
                                            <span
                                                    *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{training.prerequisites}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <label for="audience">{{ 'training-detail.training.details.audience' |
                                                translate}}</label>
                                        </div>
                                        <div class="col-md-12">
                                                <textarea class="form-control" id="audience"
                                                          [(ngModel)]="training.target_audience" name="audience"
                                                          #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'"></textarea>
                                            <span
                                                    *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{training.target_audience}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <label for="syllabus">{{ 'training-detail.training.details.syllabus' |
                                        translate}}</label>
                                </div>
                                <div class="col-md-12">
                                            <textarea class="form-control" id="syllabus"
                                                      [(ngModel)]="training.syllabus" name="syllabus" rows="8"
                                                      #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'"></textarea>
                                    <span *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{training.syllabus}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div>

                    <div style="margin:0 30px 30px;" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                        <button class="btn btn-default" type="submit">{{ 'training-detail.training.details.save' | translate}}</button>
                    </div>
                    <div *ngIf="success" class="alert alert-success">
                        <strong>Réussi !</strong>
                    </div>
                </div>
            </div>
        </form>
    </div>



// WEBPACK FOOTER //
// ./src/app/_screens/training/detail/description/description.component.html